import { ComponentProps } from "react";
import { cn } from "../../../lib/utils";

function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("rounded-md bg-[#E0E3EC] relative overflow-hidden", className)}
      {...props}
    >
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(90deg, #E0E3EC 0%, #E0E3EC 30%, #EEF0F6 50%, #E0E3EC 70%, #E0E3EC 100%)",
          width: "200%",
          height: "100%",
          animation: "shimmer 1.5s infinite ease-in-out"
        }}
      />
    </div>
  );
}

export { Skeleton };
